import { SiUpwork, SiFiverr, SiFreelancer } from "react-icons/si";
import { HOME } from "@/constants/testIds";

// Toptal & Contra don't ship in react-icons/si — use simple wordmarks.
const Wordmark = ({ children }) => (
  <span className="font-display text-[22px] font-semibold tracking-tight sm:text-[24px]">
    {children}
  </span>
);

const ITEMS = [
  { label: "Upwork",         node: <SiUpwork     className="h-8 w-8 sm:h-9 sm:w-9" /> },
  { label: "Fiverr",         node: <SiFiverr     className="h-8 w-8 sm:h-9 sm:w-9" /> },
  { label: "Freelancer",     node: <SiFreelancer className="h-8 w-8 sm:h-9 sm:w-9" /> },
  { label: "Toptal",         node: <Wordmark>TOPTAL</Wordmark> },
  { label: "Contra",         node: <Wordmark>contra</Wordmark> },
  { label: "PeoplePerHour",  node: <Wordmark>PPH</Wordmark> },
];

export function Marketplaces() {
  return (
    <section
      data-testid={HOME.marketplacesStrip}
      aria-label="Supported marketplaces"
      className="border-y border-border bg-background"
    >
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-8 sm:py-16">
        <p className="text-center text-[12px] font-medium uppercase tracking-[0.18em] text-muted-foreground">
          Trusted by freelancers winning work on
        </p>
        <div className="mt-10 grid grid-cols-3 items-center justify-items-center gap-x-6 gap-y-10 text-foreground/75 sm:grid-cols-6 sm:gap-y-8">
          {ITEMS.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 opacity-80 transition-opacity hover:opacity-100"
              aria-label={item.label}
            >
              {item.node}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
